import React from 'react'

export const World = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path="url(#clip0_8184_74829)">
      <path d="M20.0002 3.33398C29.2048 3.33398 36.6668 10.7959 36.6668 20.0007C36.6668 29.2053 29.2048 36.6673 20.0002 36.6673C10.7954 36.6673 3.3335 29.2053 3.3335 20.0007C3.3335 10.7959 10.7954 3.33398 20.0002 3.33398ZM23.334 22.3335L20.727 24.419C20.3392 24.7292 20.3072 25.3077 20.6583 25.659L22.7227 27.7231C23.1232 28.1236 23.415 28.6198 23.5707 29.1645L23.8623 30.1855C24.1252 31.105 24.7703 31.7808 25.557 32.1243C27.1605 31.3882 28.5928 30.3433 29.7778 29.0656L29.388 25.9375C29.2498 24.8315 28.568 23.8678 27.5712 23.3695L25.1205 22.1442C24.539 21.8535 23.8417 21.9273 23.334 22.3335ZM20.0005 6.66748C15.7032 6.66748 11.8807 8.70048 9.4423 11.8572L9.16715 12.2263V15.0346C9.16715 17.128 10.4692 18.9876 12.409 19.7154L12.7046 19.816L14.8556 20.4738C17.1439 21.1738 19.3721 19.3116 19.1504 16.981L19.1187 16.7383L18.8275 14.9912C18.6929 14.1834 19.1642 13.408 19.9205 13.144L20.1 13.0924L21.1197 12.8594C22.8257 12.4694 24.144 11.1146 24.4873 9.39853C24.6222 8.7243 24.5965 8.05163 24.4347 7.42255C23.0475 6.93352 21.555 6.66748 20.0005 6.66748Z"/>
    </g>
    <defs>
      <clipPath id="clip0_8184_74829">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
